import { Parser } from "@siteimprove/alfa-parser";
// Import the various simple selectors for use in that file.
import { Attribute } from "./attribute.js";
import { Class } from "./class.js";
import { Id } from "./id.js";
import { PseudoClass } from "./pseudo-class/index.js";
import { PseudoElement } from "./pseudo-element/index.js";
import { Type } from "./type.js";
import { Universal } from "./universal.js";
// Re-export the various selectors for use by others
export * from "./attribute.js";
export * from "./class.js";
export * from "./id.js";
export * from "./pseudo-class/index.js";
export * from "./pseudo-element/index.js";
export * from "./type.js";
export * from "./universal.js";
const { either } = Parser;
/**
 * @public
 */
export var Simple;
(function (Simple) {
    function isSimple(value) {
        return (Type.isType(value) ||
            Universal.isUniversal(value) ||
            Attribute.isAttribute(value) ||
            Class.isClass(value) ||
            Id.isId(value) ||
            PseudoClass.isPseudoClass(value) ||
            PseudoElement.isPseudoElement(value));
    }
    Simple.isSimple = isSimple;
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-simple-selector}
     *
     * @internal
     */
    Simple.parse = (parseSelector) => either(Class.parse, Type.parse, Attribute.parse, Id.parse, Universal.parse, PseudoClass.parse(parseSelector), PseudoElement.parse(parseSelector));
})(Simple || (Simple = {}));
//# sourceMappingURL=index.js.map